import { css } from 'lit-element';

export const ludsElevation = css`
  :host {
    --luds-elevation-1: 1px 1px 2px 0px rgba(0, 0, 0, 0.2);
    --luds-elevation-2: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    --luds-elevation-3: 0px 4px 30px 0px rgba(0, 0, 0, 0.2);
    --luds-elevetion-4: 0px 0px 4px -1px var(--colours-brand-primary);
    --luds-elevetion-5: 0px 0px 4px -1px var(--theme-link-color, --colours-brand-primary);
  }
`;
